<template>
    <div>
        <v-list dense>
            <v-list-item>
                <v-list-item-avatar>
                    <v-avatar :color="authUser.color">
                        <span class="white--text headline"> {{ authUser.avatar }} </span>
                    </v-avatar>
                </v-list-item-avatar>
                
                <v-list-item-content>
                    <v-list-item-title>{{ authUser.Comisionista }}</v-list-item-title>
                    <v-list-item-subtitle>Sesión iniciada</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item :to="{name: 'configuracion'}" exact>
                <v-list-item-action>
                    <v-icon>mdi-cog</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Configuración</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop="logout">
                <v-list-item-action>
                    <v-icon>mdi-exit-to-app</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Cerrar sesión</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
      </v-list>
    </div>
</template>

<script>
    import router from '../../router';
    import { mapState, mapActions } from 'vuex';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'UserMenu',
        props: ['drawerRight'],
        methods: {
            ...mapActions('login', ['setUser']),
            ...mapActions(['setLoading']),
            async logout () {
                this.setLoading(true);
                this.$emit('drawerRight', false);
                let respuesta = await axios.post("/logout");
                this.setUser(respuesta.data);
                this.setLoading(false);
                router.push({name: 'login'});
                sessionStorage.clear();
            }
        },
        computed: {
            ...mapState('login', ['authUser'])
        }
    }
</script>